import { useEffect, useState } from "react";
import { gsap, SplitText, useGSAP, MOTION_OK } from "./motion";

/** Splits every `.section-title` into characters and reveals them on scroll. */
export default function useTitleReveals() {
  const [fontsReady, setFontsReady] = useState(false);

  useEffect(() => {
    let alive = true;
    document.fonts.ready.then(() => alive && setFontsReady(true));
    return () => {
      alive = false;
    };
  }, []);

  useGSAP(
    () => {
      if (!fontsReady) return;
      const mm = gsap.matchMedia();
      mm.add(MOTION_OK, () => {
        gsap.utils.toArray<HTMLElement>(".section-title").forEach((title) => {
          SplitText.create(title, {
            type: "chars,words",
            mask: "words",
            autoSplit: true,
            onSplit: (self) =>
              gsap.from(self.chars, {
                yPercent: 100,
                rotate: 4,
                duration: 0.9,
                ease: "expo.out",
                stagger: { each: 0.025, from: "start" },
                scrollTrigger: { trigger: title, start: "top 85%", once: true },
              }),
          });
        });
      });
    },
    { dependencies: [fontsReady] }
  );
}
